module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdit) ? _c('NoteEditor', {
    attrs: {
      "noteData": _vm.noteData,
      "index": _vm.index
    }
  }) : _c('div', {
    class: ['note', _vm.noteData.IsTopNote ? 'topNote' : ''],
    staticStyle: {
      "background-color": "rgba(0,0,0,0.05)",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.noteData.Time) + " " + _vm._s(_vm.noteData.UserFullName))])]), _c('span', [_vm._v(" (" + _vm._s(_vm.noteData.UserType) + ")")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noteInfo)
    }
  }), _vm._v(" "), (_vm.noteData.Attachments) ? _c('div', {
    staticClass: "filesList"
  }, [_c('div', {
    staticStyle: {
      "color": "brown"
    }
  }, [_vm._v("קבצים מצורפים:")]), _vm._v(" "), _vm._l((_vm.noteData.Attachments), function(file) {
    return _c('div', [(file.Type == 'Record') ? _c('audio', {
      staticClass: "audioChat",
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": file.FileUrl,
        "type": "audio/mp3"
      }
    })]) : _c('a', {
      staticStyle: {
        "color": "blue",
        "text-decoration": "underline",
        "display": "block"
      },
      attrs: {
        "target": "_blank",
        "href": file.FileUrl
      }
    }, [_vm._v(_vm._s(file.FileName))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('div', {
    staticClass: "noteCtrls"
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'עריכה'
      }),
      expression: "{ html: 'עריכה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    on: {
      "click": function($event) {
        _vm.edit(_vm.noteData)
      }
    }
  }, [_vm._v("border_color")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": function($event) {
        _vm.confirm(_vm.noteData['.key'])
      }
    }
  }, [_vm._v("delete")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261c3ed9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Note.vue
// module id = 872
// module chunks = 2